import { render, staticRenderFns } from "./Alibaba-keywords.vue?vue&type=template&id=3f8fdebc&scoped=true&"
import script from "./Alibaba-keywords.vue?vue&type=script&lang=js&"
export * from "./Alibaba-keywords.vue?vue&type=script&lang=js&"
import style0 from "./Alibaba-keywords.vue?vue&type=style&index=0&id=3f8fdebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8fdebc",
  null
  
)

export default component.exports